var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("ComComponent", {
    ref: "comComponent",
    attrs: {
      title: "悬浮icon",
      id: _vm.id,
      keyId: _vm.keyId,
      tips: "说明：尺寸不做限制",
    },
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function (ref) {
          var configData = ref.configData
          return [
            configData.length >= 1
              ? _c(
                  "div",
                  _vm._l(
                    _vm.keyId == undefined ? [{}] : configData,
                    function (v, k) {
                      return _c(
                        "div",
                        {
                          key: k,
                          staticClass: "pop-icon",
                          on: {
                            click: function ($event) {
                              return _vm.onLocation(v.url_config)
                            },
                          },
                        },
                        [
                          _c(
                            "el-image",
                            {
                              staticClass: "img-icon",
                              attrs: { src: v.img_url, fit: "contain" },
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "image-default",
                                  attrs: { slot: "error" },
                                  slot: "error",
                                },
                                [_c("i", { staticClass: "el-icon-picture" })]
                              ),
                            ]
                          ),
                        ],
                        1
                      )
                    }
                  ),
                  0
                )
              : _vm._e(),
          ]
        },
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }